// extracted by mini-css-extract-plugin
export default {"modalWrapper":"PageInModal_modalWrapper--Rev","content":"PageInModal_content--tgA"};